import { render, staticRenderFns } from "./RiskLayers.vue?vue&type=template&id=a755cc34&scoped=true&"
import script from "./RiskLayers.vue?vue&type=script&lang=js&"
export * from "./RiskLayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a755cc34",
  null
  
)

export default component.exports